window.cambiarEstadoReview = (reviewId, estado, mercadoId) => {
    fetch("/tpanel/reviews/approve", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': '{{ csrf_token() }}'
        },
        body: JSON.stringify({
            id: reviewId,
            estado: estado,
            mercado_id: mercadoId
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Eliminamos la fila de la tabla
            const fila = document.getElementById('review-' + reviewId);
            if(fila) fila.remove();

            // Opcional: mostrar notificación
            alert(data.message);
        } else {
            alert(data.message || 'Error al actualizar la review');
        }
    })
    .catch(error => {
        console.error('Error:', error);
        alert('Error al procesar la petición');
    });
}